import { createContext } from 'react';

export const EntityReferenceResolutionContext = createContext(false);

export const SmoothdownRenderContext = createContext<{
  isAnimating: boolean;
  /**
   * The chat whose content is being rendered. Inline entities resolve their ids within it,
   * so markdown from anywhere else leaves it unset and renders none of them.
   */
  chatId: string | null;
  /** How a link to an action card draws: the whole card, the default, or its chip, as the user's own message shows it */
  actionCardLinks?: 'card' | 'chip';
}>({
  isAnimating: false,
  chatId: null,
});
